import { BehaviorSubject } from 'rxjs';
import { IAvailableFontWithStyles, IOptionalStyleForFont } from '../../../../models/configs/fonts.model';
import { IFontIDWithFamily } from '../../../../models/style-font-model';

export abstract class AvailableFontManagerAbstractClass {
    protected _allFontsSubject = new BehaviorSubject<IAvailableFontWithStyles[]>(null);
    public allFonts$ = this._allFontsSubject.asObservable();

    public abstract newFontSelectedAsync(
        data: IFontIDWithFamily,
        currentFont: IFontIDWithFamily,
        optionalStyle: IOptionalStyleForFont,
        ...args: any[]
    ): Promise<void>;
}
